module.exports = __webpack_public_path__ + "static/media/tiktok.9e3ab8e3.jpg";